import { Component, type ErrorInfo, type ReactNode } from 'react';
import { report } from '@/lib/telemetry';

/** Red de seguridad de TODA la app (pedido del propietario, 11-sep): si el
 *  árbol de React truena, el usuario ve una pantalla de mantenimiento digna
 *  — no un blanco eterno — con reintentar y el enlace al estado del
 *  servicio. El texto va HARDCODEADO en ambos idiomas a propósito: si lo
 *  que se rompió fue i18n, esta pantalla igual tiene que pintar. El error
 *  se reporta a telemetría (VLT-294) con PII enmascarada. */
interface State {
  broken: boolean;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { broken: false };

  static getDerivedStateFromError(): State {
    return { broken: true };
  }

  componentDidCatch(error: unknown, info: ErrorInfo) {
    try {
      report(error);
      if (info.componentStack) console.error('[VaulTex] ErrorBoundary:', info.componentStack.slice(0, 500));
    } catch { /* la telemetría jamás debe re-romper la pantalla de rescate */ }
  }

  render() {
    if (!this.state.broken) return this.props.children;
    return (
      <div
        role="alert"
        style={{ background: '#0f1117', color: '#e8eaf2' }}
        className="grid min-h-screen place-items-center px-6 text-center"
      >
        <div className="max-w-md space-y-4">
          <p className="font-display text-2xl font-bold" style={{ color: '#7c93f0' }}>VaulTex</p>
          <h1 className="text-xl font-semibold">Estamos en mantenimiento</h1>
          <p className="text-sm" style={{ color: '#8b90a0' }}>
            Algo falló de nuestro lado y ya lo estamos revisando. Tus datos están a
            salvo. Vuelve a intentarlo en un momento.
          </p>
          <p className="text-xs" style={{ color: '#8b90a0' }}>
            Something went wrong on our side and we are already on it. Your data is
            safe. Please try again in a moment.
          </p>
          <div className="flex items-center justify-center gap-3 pt-2">
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="rounded-xl px-4 py-2.5 text-sm font-semibold"
              style={{ background: '#2e4fc9', color: '#fff' }}
            >
              Reintentar · Retry
            </button>
            <a href="/status/" className="text-sm underline" style={{ color: '#7c93f0' }}>
              Estado del servicio
            </a>
          </div>
        </div>
      </div>
    );
  }
}
